








import { Component, Vue } from "vue-property-decorator";
import FormularioFlow from "@/components/Formularios/FormularioFlow.vue";

@Component({
  components: {
    FormularioFlow
  },
  meta: {
    // sets document title
    title: "FLOWLAB PUQ - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class FlowView extends Vue {
  private mounted() {
    document.title = "FLOWLAB PUQ - Ilustre Municipalidad de Punta Arenas";
  }
}
